import { Navigate, useParams, useLocation } from 'react-router-dom';

// Redirect an old admin path to its Phase 7 home, carrying route params and the query string along.
export const LegacyRedirect = ({ to }) => {
  const params = useParams();
  const { search } = useLocation();
  const target = Object.entries(params).reduce((acc, [k, v]) => acc.replace(`:${k}`, v), to);
  return <Navigate to={`${target}${search}`} replace />;
};
